import { TMapOffer, TMapOffersResult, TMappedBannerEntity, TMappedOfferListEntity } from '../../types/common/offer';
import { mapThemBtn } from '../../constants/mapButtonThemes';
import { EMappedTypeOffer } from '../../constants/mapOfferTypes';
import { IPersonalizedOfferProps } from '../../components/PersonalizedOffer';
import { transformOffers } from './transformOffers';
import { IOfferCardProps } from '../../components/OfferCard';
import { enrichOfferLinkWithParams } from './enrichOfferLinkWithParams';

export function getMapOffers(offers: TMapOffer[], utmTags?: Record<string, string>): TMapOffersResult {
  const arr = [];
  for (let i = 0; i < offers.length; i++) {
    if ('usp' in offers[i] && !('items' in offers[i])) {
      const mappedBannerEntity = offers[i] as TMappedBannerEntity;
      // Надо прокинуть параметры при переходе с баннера
      const enrichedBannerLink = enrichOfferLinkWithParams(mappedBannerEntity.button.path, utmTags || {});
      const btnTheme = mapThemBtn[mappedBannerEntity.button.theme];
      const personalized = {
        type: EMappedTypeOffer.PERSONALIZED,
        content: {
          ...mappedBannerEntity,
          button: { ...mappedBannerEntity.button, theme: btnTheme, path: enrichedBannerLink },
        } as IPersonalizedOfferProps,
      };
      arr.push(personalized);
    } else {
      // раскладка по мульти-фоеру и оферу
      const mappedOfferEntity = offers[i] as TMappedOfferListEntity;
      if (mappedOfferEntity.items.length > 1) {
        const mappedMultiOffer = mappedOfferEntity.items.map(el => {
          return transformOffers(el, i, utmTags);
        });
        const multi = { type: EMappedTypeOffer.MULTI, content: mappedMultiOffer as IOfferCardProps[] };
        arr.push(multi);
      } else {
        const transformedOffer = transformOffers(mappedOfferEntity.items[0], i, utmTags);
        const offer = { type: EMappedTypeOffer.OFFER, content: transformedOffer as IOfferCardProps };
        arr.push(offer);
      }
    }
  }

  return arr as TMapOffersResult;
}
